import React, { useRef, useState, useEffect } from "react";
import "./css/MobileSlider.css";

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    
    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}

function MobileSlider({id, closeGallery, advertisement_img}) {
  const sliderRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const MAX_DOTS = 10;
  
  // Tracks the active image cleanly as the user swipes natively
  const handleScroll = () => {
    const slider = sliderRef.current;
    if (!slider) return;

    const scrollLeft = slider.scrollLeft;
    const cardWidth = slider.clientWidth;

    // Calculate current slide index based on the scrolled distance
    const currentIndex = Math.round(scrollLeft / cardWidth);
    if (currentIndex !== activeIndex) {
      setActiveIndex(currentIndex);
    }
  };
  const getVisibleDotsRange = () => {
    const total = advertisement_img.length;
    
    // If total images are less than or equal to max dots, show all of them
    if (total <= MAX_DOTS) {
      return { start: 0, end: total };
    }

    // Determine the ideal start index to keep the active dot centered
    let start = activeIndex - Math.floor(MAX_DOTS / 2);
    
    // Clamp boundaries so the subset stays exactly at MAX_DOTS length
    if (start < 0) {
      start = 0;
    } else if (start + MAX_DOTS > total) {
      start = total - MAX_DOTS;
    }

    return { start, end: start + MAX_DOTS };
  };
  const { start, end } = getVisibleDotsRange();
  const visibleDots = advertisement_img.slice(start, end);
  return (
    <div className="mobile-slider-container">
      <span className="close-modal" onClick={closeGallery}>
        &times;
      </span>
      {/* Native-scrolling touch viewport */}
      <div 
        ref={sliderRef}
        className="mobile-slider-wrapper"
        onScroll={handleScroll}
      >
        <ul className="mobile-slider-carousel">
          {advertisement_img?.map((src, index) => (
            <li key={index} className="mobile-slider-card">
              <img src={`/images/${id}/advertisement/${advertisement_img[index]}`} />
            </li>
          ))}
        </ul>
      </div>
      <div className="mobile-slider-dots">
        {visibleDots.map((_, index) => {
          // Remap the sliced item index back to its true global array index
          const trueIndex = start + index;
          return (
            <span 
              key={trueIndex} 
              className={`dot ${trueIndex === activeIndex ? "active" : ""}`}
            />
          );
        })}
      </div>
    </div>
  );
}

function DesktopModal({ id, index, closeGallery, advertisement_img }) {
  const [currentIndex, setCurrentIndex] = useState(index);
  function nextImage(){
    let newIndex = currentIndex+1;
    if(newIndex >= advertisement_img.length){
      newIndex = 0;
    }
    setCurrentIndex(newIndex);
  }

  function prevImage(){
    let newIndex = currentIndex-1;
    if(newIndex < 0){
      newIndex = advertisement_img.length - 1;
    }
    setCurrentIndex(newIndex);
  }
  return (
    <div id="galleryModal" className="gallery-modal">
      <span className="close-modal" onClick={closeGallery}>
        &times;
      </span>
      <button className="nav-btn prev-btn" onClick={() => prevImage()}>
        ‹
      </button>
      <img src={`/images/${id}/advertisement/${advertisement_img[currentIndex]}`} className="modal-image" />
      <button className="nav-btn next-btn" onClick={() => nextImage()}>
        ›
      </button>
    </div>
  )
}

export default function ReportModal({ id, index, closeGallery, advertisement_img }) {
  const width = useWindowWidth();
  const breakpoint = 768; // Mobile breakpoint in pixels
  if (width < breakpoint) {
    return <MobileSlider id={id} closeGallery={closeGallery} advertisement_img={advertisement_img} />;
  }

  return <DesktopModal id={id} index={index} closeGallery={closeGallery} advertisement_img={advertisement_img} />;
}

